export enum MasterMenus {
  OPD = "Patient_Management",
  Billing = "Billing",
  Lab = "Lab",
  APP = "APP",
  PROCUREMENT = "Procurement",
  MRD="MRD_Department",
  PHARMACY="Pharmacy",
  INVENTORY = "Inventory",
  SYSTEM = "System",
}

export enum MasterSubMenus {
  glapproval = "glapproval",
  Bill = "Bill",
  Registration = "Registration",
  Phlebotomy = "Phlebotomy",
  Encounter = "Encounter",
  Charges = "Charges",
  ERRegistration="ER Registration",
  SampleReg="Sample Registration"
}

export enum MasterChildSubMenus {
  CentralReceiving = "Central Receiving"
}

export enum MasterKeys {
  IsREDUNDANTRADIOLOGYPRINTBUTTONREMOVED = "IS_REDUNDANT_RADIOLOGY_PRINT_BUTTON_REMOVED",
  OutsourceLabResultApproval = "Is_OutsourceLab_ResultApproval",
  VisitDate = "VISIT_DATE_VALIDITY",
  performaRequired = "Is_performa_required",
  tariffConfig = "Default_Tariff",
  depositAlias = "D_Payment_Alias_Name",
  tariffDiscountType = "TARIFF_DISCOUNT_TYPE",
  contractDiscountType = "CONTRACT_DISCOUNT_TYPE",
  selfSettlementFlag = "SELF_SETTLEMENT_MANDATORY",
  defaultSelfContract = "Default_Self_Contract",
  StaffPatientCategory = "StaffPatientCategory",
  StudentPatientCategory = "StudentPatientCategory",
  NextOfKinRequired="Kin Details Required",
  staffActiveFlag="Is_Staff_Active_Requierd",
  servicePurchaseRequired = "Service Purchase Required",
  isRaceDependentRequired ="IsRaceDependentRequired",
  updateAuthRequired="Update Authentication Required",
  patientCategoryTariffRequired="PatientCategoryTariffMapperRequired",
  mrdReport="MRD_Report",
  firstPayerPriorityRequired="Payer_DefaultFirstPriorityRequired",
  patientCardRequired="Patient Card Required",
  defaultNationality="Default Nationality",
  defaultCountry="Default Country",
  emergencyDoctor="EmergencyDoctor",
  isDefaultDepositRequired ="IsDefaultDepositRequired",
  NewBorndefaultspecialty ="New Born default specialty",
  DefaultCountryCode = "Default Country Code",
  isAdmissionDateEditable="Admission Date Editable",
  defaultFinancialClass="Default Financial Class",
  ExpiryDurationAlerts = "Expiry_Duration_Alerts",
  searchByPostCode = "Search_By_Postcode",
  primaryIdentification = "primary Identification",
  defaultSelectionRequired = "Default Selection Required",
  IsMRPRequiredOnGRN = "IsMRPRequiredOnGRN",
  defaultCashCounter = "Default Cash Counter",
  consultationChargesDuringvisit = "consultation_charges_during_visit",
  autoBillScreenRedirection = "Auto Billing Screen Redirection",
  SalesTaxInclusive = "Sales Tax Inclusive",
  patientNameLtwo="patient_Name_in_Ltwo",
  fullName="full_Name",
  babyOfPrefix="Baby Of Prefix",
  allowedRecurringAppointments ="AllowedRecurringAppointments",
  ReportPrintVerification = "Report_Print_Verification",
  isUnitWisePatientSearch="IsUnitWisePatientSearch",
  HighRiskMedicationVerification = "High Risk Medication Verification",
  DefaultPatientCategory="Default Patient Category",
  isAiImageSearch = "IsAiImageSearch",
  SEPERATE_IDENTIFICATION_TYPE_BASED_ON_PRIMARY_FOR_SRIPHAT = "SEPERATE_IDENTIFICATION_TYPE_BASED_ON_PRIMARY_FOR_SRIPHAT",
  AutoLabelAtPreparation = "Auto_Label_At_Preparation",
  MultiInvoiceAllowed = "Multi Invoice Allowed",
  MedHistoryCheckDuration = "Med history check duration",
  rePrintPatientCard = "Re_Print_Patient_card",
  ER_Auto_Print_PDPA_Form = "ER_Auto_Print_PDPA_Form",
  ERRegistrationDefaultUnknown = "ER Registration Default Unknown",
  cssdStore="CSSD Store Master",
  PR_Cost_Visibility = "PR Cost Visibility",
  PO_Two_Level_Verification = "PO Two-Level Verification",
  IsLetterOfUndertaking="IsLetterOfUndertaking",
  Is_Prefix_Requied_In_Lables="Is_Prefix_Requied_In_Lable",
  Material_Auto_Consume = "Material Auto Consume",
  show_critical_health_tab="ShowCriticalHealthTab",
  is_Identification_Required_Quick_Registration= "Is_Identification_Rquired_Quick_Registration",
  Is_Government_Code_Required="Is_GOVERNMENT_CODE_RQUIRED",
  show_Registration_Document_Upload = "SHOW_REGISTERATION_DOCUMENT_UPLOAD",
  ALLOW_CARE_PROVIDER_TO_BE_CHANGED="ALLOW_CARE_PROVIDER_TO_BE_CHANGED",
  ALLOW_MED_RETURN_AFTER_INVOICE="ALLOW_MED_RETURN_AFTER_INVOICE",
  Is_Active_Visit_Required_For_Medical_Report="Is_Active_Visit_Required_For_Medical_Report",
  PO_ROUNDING_OFF = "PO_ROUNDING_OFF",
  IS_KIN_GUARANTOR_REQ = "IS_KIN_GUARANTOR_REQ",
  Bill_Estimation_Default_Store = "Bill_Estimation_Default_Store",
  DOCTOR_SHARE_VALUE_IN_PERCETAGE = "DOCTOR_SHARE_VALUE_IN_PERCETAGE",
  SST_Required = "SST Required",
  Default_Appt_Type="Default_Appt_Type",
  Default_Consultation_Type="Default_Consultation_Type",
  Default_Appt_Dept="Default_Appt_Dept",
  IS_NEED_TRANSLATOR="IS_NEED_TRANSLATOR",
  APPLY_TAX_VALIDATION="APPLY_TAX_VALIDATION",
  ED_Clinic="ED_Clinic",
  Is_Foreign_Patient_Expiry_Date_Required="Is_Foreign_Patient_Expiry_Date_Required",
  Is_Ward_Bed_Mandatory="Is_Ward_Bed_Mandatory",
  DISPLAY_USERNAME_AFTER_PATIENT_CONSUMPTION = "DISPLAY_USERNAME_AFTER_PATIENT_CONSUMPTION",
  AllowCNandDNAfterInvoiceSubmission = "AllowCNandDNAfterInvoiceSubmission",
  Is_Department_wise_cabin="Is_Department_wise_cabin",
  otpRequiredForLogin = "isOtpRequiredForLogin",
  dispenseWithoutBilling_IsInClinicFlag = "dispenseWithoutBilling_IsInClinicFlag",
  SHOW_PATIENT_PREFIX="SHOW_PATIENT_PREFIX",
}
export enum ScreenLockEnum {
  billscreenTypeCode= "BILL",
  statusCode= "REL",
  opbill = "opbill",
  ipbill = "ipbill",
  addGrn = "addnewGrn",
  grnScreenTypeCode = "AGAINSTPO",
  medicationOrder = "medicationorder-dashboard",
  medicationOrderScreenTypeCode = "MEDICATIONORDER"
}
export enum ManditoryKayEnum{
  clinic="clinic"
}
